import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3d8e5a8d&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8e5a8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d8e5a8d')) {
      api.createRecord('3d8e5a8d', component.options)
    } else {
      api.reload('3d8e5a8d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3d8e5a8d&scoped=true&", function () {
      api.rerender('3d8e5a8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/PriceLCL/index.vue"
export default component.exports